import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = ({ message, inline = false }) => {
  if (inline) {
    return (
      <div className="loading-spinner-inline">
        <div className="spinner-core small"></div>
        {message && <p className="loading-text small">{message}</p>}
      </div>
    );
  }

  return (
    <div className="loading-spinner-overlay">
      <div className="loading-spinner-content">
        <div className="minimal-spinner"></div>
        {message && <p className="loading-text-simple">{message}</p>}
      </div>
    </div>
  );
};

export default LoadingSpinner;
